import type { SpreadReadingProfile } from "../types";

export const periodicForecastReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_periodic_forecast",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
  ],
};

